import { priceNormelizer } from "./tags";
import { stringEquals } from "./string-helpers";
import { getPriceWithoutTax } from "./priceCalculationHelper";
import { changeDateToMomentFormat } from "../helpers/dateHelpers";

export const convertPriceToSelectedCurrency = (
  price,
  selectedCurrencyCode,
  currentCurrencyCode,
  fallBackCurrencySymbol,
  currencies,
  taxesPrecentage,
  displayPriceWithoutTaxes,
  showPricePerNightThumb,
  checkinDate,
  checkoutDate
) => {
  if (displayPriceWithoutTaxes) {
    price = getPriceWithoutTax(price, taxesPrecentage);
  }
  if (showPricePerNightThumb) {
    const nights = calculateNights(checkinDate, checkoutDate);
    price = price / nights;
  }
  if (
    !selectedCurrencyCode ||
    !currentCurrencyCode ||
    !currencies ||
    !currencies.length
  ) {
    return priceNormelizer`${fallBackCurrencySymbol}${price}`;
  }

  const selectedCurrencyObj = currencies.find(cur =>
    stringEquals(cur.currencyCode, selectedCurrencyCode)
  );

  let currenctCurrencyObj = currencies.find(cur =>
    stringEquals(cur.currencyCode, currentCurrencyCode)
  );

  const priceInSelectedCurrency =
    selectedCurrencyObj && selectedCurrencyObj.rate !== 0 && currenctCurrencyObj
      ? (price * (currenctCurrencyObj.rate / currenctCurrencyObj.unit)) /
        (selectedCurrencyObj.rate / selectedCurrencyObj.unit)
      : price;

  const normalizedPrice = priceNormelizer`${
    selectedCurrencyObj ? selectedCurrencyObj.symbol : fallBackCurrencySymbol
  }${priceInSelectedCurrency}`;

  return normalizedPrice;
};

export const calculateNights = (checkin, checkout) => {
  let result = "";
  if (checkin && checkout) {
    const ciMoment = changeDateToMomentFormat(checkin, ".");
    const coMoment = changeDateToMomentFormat(checkout, ".");
    result = coMoment.diff(ciMoment, "days");
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/helpers/currencyHelpers.js